import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { PostData } from '../../services/PostData';
import { GetData } from '../../services/GetData';
import {
	Row,
	Col,
	Button,
	ButtonDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Card,
	CardHeader,
	CardFooter,
	CardBody,
	Collapse,
	Form,
	FormGroup,
	FormText,
	Label,
	Input,
	InputGroup,
	InputGroupAddon,
	InputGroupText,
	Table
} from 'reactstrap';
import $ from 'jquery';
import AcademicPage from '../../views/AcademicPage/';
const GLOBAL = require('../../Globals');

class SubjectAllocation extends Component {

	/** set property value **/
	constructor(props) {
		super(props);
		this.state = {
			id: '',
			teacher: '',
			subject: '',
			acyear: '',
			empname: '',
			depart: '',
			chk: '',
			_message: '',
			alertClass: '',
			accyear: [],
			depat: [],
			sub: [],
			emp: [],
			data: [],
			postFilter: [],
			_redirect: false,
			timetab: [],
		}
		this.onSearchChange = this.onSearchChange.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onChangeAlert = this.onChangeAlert.bind(this);
	}

	onChangeAlert() {

		alert('Allocated...');
	}

	onSearchChange(e) {

		this.state.empname = e.target.value;
		console.log(this.state);
		this.filterdata();
	}

	handleChange(id, subj, e) {

		this.state.teacher = id;
		this.state.subject = subj;

		if (e.target.checked) {

			this.state.chk = '1';
		}
		else {

			this.state.chk = '0';
		}

		console.log(this.state);

		if (this.state.acyear && this.state.depart && this.state.teacher && this.state.subject) {
			$("#showLoader").show();
			PostData('subjectallocation/add', this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if (responseJson.status == '1') {
					this.getdata();
				}
				else {

					this.setState({
						_message: 'Already Added',
						alertClass: 'alert alert-danger'
					});
					this.getdata();
				}
			});
		}
	}

	onChange(e) {
		this.setState({ [e.target.name]: e.target.value });
		this.getemployee();
		this.getdata();
		this.gettimetab();
		console.log(this.state);
	}

	componentWillMount() {

		this.getdepartment();
		this.getsubject();
		this.getacyear();
	}

	/** Get TimeTable Data **/
	gettimetab() {
		var ac = this.state.acyear;
		$("#showLoader").show();
		GetData('timetable/gettimetabelbyac/' + ac).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					timetab: responseJson
				});
			}
		});
	}

	/** Get Academic Year **/
	getacyear() {

		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					accyear: responseJson
				});
				var index = responseJson.findIndex(function (obj) {
					return (obj.iscurrent == 1);
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear: responseJson[index].id
				});
				$('#year option').eq(index + 1).prop('selected', true).trigger('change');
			}
		});
	}

	/** Get Subject Allocation Details By Academic Year **/
	getdata() {
		var ac = $("#year").val();
		var dt = $("#dept").val();
		$("#showLoader").show();
		GetData('subjectallocation/getsuball/' + ac + '/' + dt).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					data: responseJson
				});
			}
		});
	}

	/** get Employee By Department **/
	getemployee() {
		var dt = $("#dept").val();
		$("#showLoader").show();
		GetData('employee/getempbydept/' + dt).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					emp: responseJson,
					postFilter: responseJson
				});
			}
		});
	}

	/** get Department **/
	getdepartment() {

		GetData('department/getdepartment').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					depat: responseJson
				});
			}
		});
	}

	/** get Subject **/
	getsubject() {

		GetData('subject/getsubject').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					sub: responseJson
				});
			}
		});
	}

	getcheck(id) {

		var formFields = [];
		for (var i = 0; i < this.state.sub.length; i++) {
			console.log(this.state.sub[i].id);
			if (this.getsubtea(id, this.state.sub[i].id)) {
				if (this.checkteacher(id, this.state.sub[i].id)) {

					formFields.push(<td><input type="checkbox" id="chksec" checked onClick={this.onChangeAlert} /></td>);
				}
				else {
					formFields.push(<td><input type="checkbox" defaultChecked={true} onClick={this.handleChange.bind(this, id, this.state.sub[i].id)} /></td>);
				}
			}
			else {
				formFields.push(<td><input type="checkbox" onClick={this.handleChange.bind(this, id, this.state.sub[i].id)} /></td>);
			}
		}
		return (formFields);
	}

	checkteacher(tea, sub) {

		var bstate = false;
		for (var ii = 0; ii < this.state.timetab.length; ii++) {

			if (this.state.timetab[ii].teacher == tea && this.state.timetab[ii].subject == sub) {

				bstate = true;
				break;
			}
			else {
				bstate = false;
			}

		}
		return bstate;
	}

	getsubtea(tea, sub) {

		var boolstate = false;
		for (var ii = 0; ii < this.state.data.length; ii++) {

			if (this.state.data[ii].employee == tea && this.state.data[ii].subject == sub) {

				boolstate = true;
				break;
			}
			else {
				boolstate = false;
			}

		}
		return boolstate;
	}



	render() {

		$("#myInput").on("keyup", function () {
			var value = $(this).val().toLowerCase();
			$("#xtable tr").filter(function () {
				$(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
			});
		});

		if (this.state._redirect) {

			return (<Redirect to={'/academic/updatesection/' + this.state.idd} />);

		}

		if (this.state.acyear != '' && this.state.depart != '') {

			$("#suballtable").show();
			$("#subalbody").show();
		}
		else {

			$("#suballtable").hide();
			$("#subalbody").hide();
		}

		var items = this.state.posts;
		var acyear = this.state.accyear;
		var dept = this.state.depat;

		return (
			<div>
				<AcademicPage />
				<div className="animated fadeIn">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<Row>
						<Col md="12">
							<Card>
								<form action="" method="post" role="form" id="subform" encType="multipart/form-data" onSubmit={this.onSubmit} >
									<CardHeader>
										<strong>Subject Allocation</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
										Academic Year : &nbsp;&nbsp;
							<select name="acyear" onChange={this.onChange} required id="year">
											<option value="">Select Academic Year</option>
											{
												acyear.map(function (item) {
													return <option value={item.id}>{item.value}</option>;
												})
											}
										</select>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
										Department : &nbsp;&nbsp;
							<select name="depart" onChange={this.onChange} required id="dept" >
											<option value="">Select Department</option>
											<option value="all">All</option>
											{
												dept.map(function (item) {
													return <option value={item.id}>{item.department}</option>;
												})
											}
										</select>&nbsp;&nbsp;
										Employee Name : &nbsp;&nbsp;
								<input type="text" name="empname" id="myInput" />&nbsp;&nbsp;
						</CardHeader>
									<CardBody id="subalbody">
										<Row>
											<Col md="12">
												<Table responsive bordered id="suballtable">
													<thead className="headcol">
														<tr>
															<td>#</td>
															{this.state.sub.map(item =>

																<td>{item.sub}</td>
															)}
														</tr>
													</thead>
													<tbody className="" id="xtable">
														{this.state.emp.map((item, index) =>

															<tr key={index}>
																<td width="220px">
																	<span id="subtext">{item.empname}</span><br></br>
																	({item.designation} - {item.department})
											</td>
																{this.getcheck(item.id)}
															</tr>
														)}
													</tbody>
												</Table>
											</Col>
										</Row>
									</CardBody>
								</form>
							</Card>
						</Col>
					</Row>
				</div>
			</div>
		)
	}
}

export default SubjectAllocation;


// WEBPACK FOOTER //
// ./src/subject/SubjectAllocation/SubjectAllocation.js